module.exports = __webpack_public_path__ + "static/technology-chip-8ddc433058524abe26fc8eec39f96faa.jpeg";